import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ServiceService } from '../../../service/service.service';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { selectService } from '../../../store/service/service.selectors';
import { selectUrl } from '../../../../../store/global/router.selector';
import { map } from 'rxjs';

interface State {
}

const defaultState: State = {};

@Injectable()
export class ServicesSettingsPageStore extends ComponentStoreFactory<State, ServiceService> {

    service$ = this.globalStore!.select(selectService);

    activeIndex$ = this.globalStore!.select(selectUrl).pipe(
        map((url) => {
            const lookFor = 'settings/';
            const root = url.substring(url.indexOf(lookFor) + lookFor.length);
            let index = root.indexOf('/');
            if (index <= 0) index = root.length;

            return root.substring(0, index);
        }),
    );

    constructor() {
        super(defaultState, inject(Store), inject(ServiceService));
    }

}
